import React from 'react';

import APPCONFIG from "constants/Config";
import Framework from "@beardeddevops/react.framework";
import {Breadcrumb, Collections} from "components";


export default class Access_Logs extends Framework.Components.View {

	constructor(props) {
		super(props);
		this.state.pawn_ticket = '';
	}


	render() {
		return (
			<div className="container-fluid">

				<div className="page-bar">
					<ul className="page-breadcrumb">
						<Breadcrumb name={"Access Log"} url={"/access"} icon={"file-text-o"}/>
					</ul>
				</div>

				<Framework.Errors.General isDev={APPCONFIG.settings.isDev()} >
					<Collections.AccessLogs
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						locations={this.props.locations}
					/>
				</Framework.Errors.General>

			</div>
		);
	}
}


